export enum CalendarViewType {
  WEEK,
  DAY,
}

/**
 * Generic event rendered by the Calendar component.
 * `data` carries an arbitrary payload returned to `onEventClick` (e.g. the
 * underlying appointment), so consumers can react without the calendar knowing
 * about their domain types.
 */
import { ComponentType } from "react";

export interface CalendarEvent {
  from: Date | string;
  to: Date | string;
  title?: string;
  /** Accent color for the border/icons. Defaults to "primary" (blue); "secondary" is gold. */
  color?: "primary" | "secondary";
  /** Optional leading icon (e.g. to mark a recurring vs one-off event). */
  icon?: ComponentType<{ className?: string }>;
  /** Optional icon shown in the top-right corner (e.g. a category marker). */
  cornerIcon?: ComponentType<{ className?: string }>;
  data?: unknown;
}
